import { useEffect, useState } from "react";
import { isPrerendering } from "../utils/isPrerendering";

/** Always false on first paint so prerendered HTML matches hydrate. */
export function useInViewAfterMount(ref, { amount = 0, once = false } = {}) {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (isPrerendering()) return undefined;
    const el = ref.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (once) observer.disconnect();
        } else if (!once) {
          setInView(false);
        }
      },
      { threshold: amount }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [amount, once, ref]);

  return inView;
}
